/**
 * Zero hour constant
 */
export const ZERO_HOUR = '0:00';
